import { render, staticRenderFns } from "./SubscriptionPlansFilter.vue?vue&type=template&id=812a1142&"
import script from "./SubscriptionPlansFilter.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlansFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports